import { dashesToDots } from "./helpers";

export const getContactPath = () => "/kontakt";

export const getAboutProjectPath = () => "/o-projekte";

export const getLocalityPath = () => "/lokalita";

export const getFinancePath = () => "/financovanie";

export const getOfferPath = () => "/ponuka";

export const getGalleryPath = () => "/galeria";

export const getPartnersPath = () => "/partneri";

export const getFlatPath = (flatId?: string) =>
  flatId ? `/byt/${dashesToDots(flatId)}` : "/byt";
